export default __webpack_public_path__ + "static/kits-results-b28c2e441263af7d08ec59b8da06a578.png";